{
  "DATE_PICKER": {
    "APPLY_BUTTON": "Použít",
    "CLEAR_BUTTON": "Vymazat",
    "DATE_RANGE_INPUT": {
      "START": "Počáteční datum",
      "END": "Koncové datum"
    },
    "DATE_RANGE_OPTIONS": {
      "TITLE": "ČASOVÉ OBDOBÍ",
      "TODAY": "Dnes",
      "YESTERDAY": "Včera",
      "LAST_7_DAYS": "Posledních 7 dní",
      "LAST_30_DAYS": "Posledních 30 dní",
      "LAST_3_MONTHS": "Poslední 3 měsíce",
      "LAST_6_MONTHS": "Posledních 6 měsíců",
      "LAST_YEAR": "Poslední rok",
      "CUSTOM_RANGE": "Vlastní časové rozmezí"
    }
  }
}